module.exports = __webpack_public_path__ + "img/Trade (3).02265b7b.svg";